import TaxiCorporationListResponse, {
  TaxiCorporationListResponseItem,
} from "../../../api/raily/taxi-corporation/list/taxi-corporation-list.response";
import TaxiCorporationList, {
  TaxiCorporationListItem,
} from "./taxi-corporation-list";

const createDataItem = (
  responseDataItem: TaxiCorporationListResponseItem
): TaxiCorporationListItem => {
  return {
    uuid: responseDataItem.id,
    name: responseDataItem.companyName,
    displayName: responseDataItem.displayName,
    address: responseDataItem.headquartersAddressString,
    nationalCourtRegister: responseDataItem.krsNo,
    notes: responseDataItem.notes,
    companyId: responseDataItem.regon,
    taxNumber: responseDataItem.taxId,
    isCsi: responseDataItem.isCsi ?? false,
  };
};

const createData = (
  responseData: TaxiCorporationListResponseItem[]
): TaxiCorporationListItem[] => {
  return responseData.map(createDataItem);
};

const create = (response: TaxiCorporationListResponse): TaxiCorporationList => {
  return {
    data: createData(response.data.data),
    totalCount: response.data.totalCount,
  };
};

const taxiCorporationListFactory = {
  create,
};

export default taxiCorporationListFactory;
